
import { _, locale } from "i18n";
import { useContext, useState } from "react";
import { Link } from "react-router"
import Loader from "ui-kit/src/Loader/Loader"
import Modal from "ui-kit/src/Modal"
import { getDateFormat } from "ui-kit/src/functions";
import { mergeCloseTimeSpanEvents } from "../../../../gamePage/functions";
import type { EventListTeamInfo, GameClipResponse, GameClipsRowResponse, User } from "../../../types";
import { ClipPlayerModal } from "./ClipPlayerModal";

interface GameClipCard {
    selectedClipId: number;
    clip: GameClipsRowResponse;
    showClip: boolean;
    selectedClip?: GameClipResponse;
    isLoading: boolean;
    setShowClip: (show: boolean) => void;
    onEdit: (id: number, name: string, description?: string) => void;
    onDelete: (id: number) => void;
    selectClip: (id: number) => void;
    handleShareClip: (id: number) => void;
    teamInfo: EventListTeamInfo;
    isAdmin?: boolean;
    showShareButton?: boolean;
}

export function GameClipCard({
    isAdmin,
    showShareButton = true,
    teamInfo,
    selectedClipId,
    isLoading,
    clip,
    showClip,
    selectedClip,
    setShowClip,
    onEdit,
    onDelete,
    selectClip,
    handleShareClip,
}: GameClipCard) {
    const [edit, setEdit] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [nameValue, setNameValue] = useState(clip.name);
    const [descValue, setDescValue] = useState(clip.description);

    const dateOptions: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
    };

    const formattedDate = new Intl.DateTimeFormat(getDateFormat(locale), dateOptions).format(new Date(clip.createdAt ?? ""));

    const handleCancelEdit = () => {
        setEdit(false);
        setNameValue(clip.name);
        setDescValue(clip.description);
    }

    const handleSubmitEdit = () => {
        setEdit(false);
        onEdit(clip.id, nameValue, descValue ?? "");
    }


    const onClipSelect = (id: number, url: string | null) => {
        if (url !== null) {
            if (id === selectedClip?.id) {
                selectClip(0);
                setShowClip(false);
            }
            else {
                selectClip(id);
                setShowClip(true);
            }
        }
    }

    return (
        <div>
            <div className="gameClipCard-container" style={clip.isFinished ? {} : { filter: "grayscale(1)" }} onClick={() => onClipSelect(clip.id, clip.url)} >
                <div className="gameClipCard-left">
                    <div className="gameClipCard-thumb">
                        <span className="icon-new icon-play icon-white icon-16" />
                    </div>
                    <div className="gameClipCard-info">
                        <div className="gameClipCard-text">
                            {edit ?
                                <div onClick={e => e.stopPropagation()}>
                                    <input className="gameClipCard-editInput" placeholder={_("gamePage.label.clipName")} value={nameValue} onChange={(e) => setNameValue(e.target.value)} />
                                    -
                                    <input className="gameClipCard-editInput" placeholder={_("gamePage.label.clipDescription")} value={descValue ?? ""} onChange={(e) => setDescValue(e.target.value)} />
                                    <span className="icon-new icon-checkmark icon-12" onClick={() => handleSubmitEdit()} />
                                    <span className="icon-new icon-cross icon-12" onClick={() => handleCancelEdit()} />
                                </div>

                                :
                                <>
                                    <div className="gameClipCard-title" >{`${clip.name}`}</div>
                                    {clip.description && <div className="gameClipCard-desc"> - {`${clip.description}`}</div>}
                                </>
                            }

                        </div>
                        <div className="gameClipCard-date">{`${_("label.created_date")}: ${formattedDate}`}</div>
                        {/* Events count: {clip.eventsCount} */}
                    </div>
                </div>
                {clip.isFinished &&
                    <div className="gameClipCard-right">
                        {!isAdmin && showShareButton && <div className="gameClipCard-share">
                            <span className="icon-new icon-share-new icon-22" onClick={(e) => {
                                handleShareClip(clip.id);
                                e.stopPropagation();
                            }} />
                        </div>}
                        {clip.url &&
                            <Link to={clip.url} className="gameClipCard-download" onClick={(e) => {
                                e.stopPropagation();
                            }}>
                                <span className="icon-new icon-download icon-24" />
                            </Link >
                        }
                        <div className="gameClipCard-edit" onClick={(e) => {
                            setEdit(!edit)
                            e.stopPropagation();
                        }}>
                            <span className="icon-new icon-crayon icon-18 icon-black" />
                        </div>
                        <div className="gameClipCard-delete" onClick={(e) => {
                            setShowDeleteModal(true)
                            e.stopPropagation();

                        }}>
                            <span className="icon-new icon-bin icon-18" />
                        </div>

                    </div>
                }
                <Modal size="sm" onClose={() => setShowDeleteModal(false)} show={showDeleteModal} title={_("gamePage.message.deleteClip.title")}>
                    <div className="gameClipDeleteModal-container">
                        <div className="gameClipDeleteModal-text">
                            {_("gamePage.message.deleteClip")}
                        </div>
                        <div className="gameClipDeleteModal-buttons">
                            <button className="deleteModalButton submit" type="button" onClick={(e) => {
                                onDelete(clip.id)
                                e.stopPropagation();
                            }}>{_("common.action.delete")}</button>
                            <button className="deleteModalButton cancel" type="button" onClick={(e) => {
                                setShowDeleteModal(false)
                                e.stopPropagation();
                            }}>{_("btn.cancel")}</button>
                        </div>
                    </div>
                </Modal >
            </div>
            {
                showClip && (selectedClipId === clip.id) &&
                (isLoading ?
                    <div className="clipLoader-container">
                        <Loader />
                    </div>
                    :
                    (selectedClip && <ClipPlayerModal eventCount={selectedClip.events.length} teamInfo={teamInfo} clip={selectedClip} mergedEvents={mergeCloseTimeSpanEvents(selectedClip.events)} />)
                )
            }
        </div>
    )
}
